// extracted by mini-css-extract-plugin
export default {"wrapper":"ParishInfoCard_wrapper__zftUB"};